<app-navbar *ngIf="isLoaded" [profile]="me" [menuItems]="menuItems">
  <router-outlet></router-outlet>
</app-navbar>
